import React from "react";
import CIcon from "@coreui/icons-react";
import { freeSet } from "@coreui/icons";
const _nav = [
  {
    _tag: "CSidebarNavItem",
    name: "Home",
    to: "/dashboard",
    icon: <CIcon name="cil-chart-pie" customClasses="c-sidebar-nav-icon" />,
  },
  {
    _tag: "CSidebarNavDropdown",
    name: "Salary Advance",
    route: "/loan",
    icon: "cil-notes",
    _children: [
      {
        _tag: "CSidebarNavItem",
        name: "Loan Requests",
        to: "/loan/request",
        badge: {
          color: "success",
          text: "10",
        },
      },
      {
        _tag: "CSidebarNavItem",
        name: "Active Loan",
        to: "/loan/active",
      },
      {
        _tag: "CSidebarNavItem",
        name: "Overdue Loan",
        to: "/loan/overdue",
      },
      {
        _tag: "CSidebarNavItem",
        name: "Settled Loan",
        to: "/loan/settled",
      },
    ],
  },
  {
    _tag: "CSidebarNavDropdown",
    name: "Goal",
    route: "/goal",
    icon: "cil-notes",
    _children: [
      {
        _tag: "CSidebarNavItem",
        name: "Active",
        to: "/goals/active",
      },
      {
        _tag: "CSidebarNavItem",
        name: "Complete",
        to: "/goals/complete",
      },
      {
        _tag: "CSidebarNavItem",
        name: "Overdue",
        to: "/goals/overdue",
        badge: {
          color: "danger",
          text: "10",
        },
      },
      {
        _tag: "CSidebarNavItem",
        name: "inactive",
        to: "/goals/inactive",
        badge: {
          color: "success",
          text: "10",
        },
      },
    ],
  },
  {
    _tag: "CSidebarNavDropdown",
    name: "Payments",
    route: "/payment",
    icon: "cil-list",
    _children: [
      {
        _tag: "CSidebarNavItem",
        name: "Received Cash",
        to: "/payment/received",
      },
      {
        _tag: "CSidebarNavItem",
        name: "Withdrawn Cash",
        to: "/payment/settlement",
      },
      {
        _tag: "CSidebarNavItem",
        name: "Refunds",
        to: "/payment/refund",
      },
    ],
  },
  {
    _tag: "CSidebarNavDropdown",
    name: "Baas accounts",
    route: "/baas",
    icon: "cil-list",
    _children: [
      {
        _tag: "CSidebarNavItem",
        name: "Baas Accounts",
        to: "/baas/account",
      },
      {
        _tag: "CSidebarNavItem",
        name: "Baas Topups",
        to: "/baas/topups",
      },
      {
        _tag: "CSidebarNavItem",
        name: "Withdraw Request",
        to: "/admin/baas/withdrawal/request",
      },
    ],
  },

  {
    _tag: "CSidebarNavDropdown",
    name: "Customers",
    route: "/customer/",
    icon: "cil-user",
    _children: [
      {
        _tag: "CSidebarNavItem",
        name: "Approved",
        to: "/customer/approved",
      },
      {
        _tag: "CSidebarNavItem",
        name: "Not-Approved",
        to: "/customer/new",
      },
      {
        _tag: "CSidebarNavItem",
        name: "Suspended",
        to: "/customer/suspended",
      },
    ],
  },
  {
    _tag: "CSidebarNavDropdown",
    name: "Corporate",
    route: "/corporate/",
    icon: "cil-bookmark",
    _children: [
      {
        _tag: "CSidebarNavItem",
        name: "All Corporate",
        to: "/corporate/list",
      },
      {
        _tag: "CSidebarNavItem",
        name: "Account Managers",
        to: "/corporate/manager/list",
      },
      {
        _tag: "CSidebarNavItem",
        name: "Invoices",
        to: "/admin/invoices",
      },
      {
        _tag: "CSidebarNavItem",
        name: "Invoice Settlements",
        to: "/admin/settlements",
      },
      {
        _tag: "CSidebarNavItem",
        name: "Bulk payment(coming soon)",
        to: "/partner/bulk/list",
      },
      {
        _tag: "CSidebarNavItem",
        name: "Staff Savings(coming soon)",
        to: "partner/staff/saving",
      },
    ],
  },
  {
    _tag: "CSidebarNavDropdown",
    name: "Messages",
    route: "/message",
    icon: "cil-code",
    _children: [
      {
        _tag: "CSidebarNavItem",
        name: "Received",
        to: "/message/inbox",
      },
      {
        _tag: "CSidebarNavItem",
        name: "Sent out",
        to: "/message/outbox",
      },
    ],
  },
  {
    _tag: "CSidebarNavDropdown",
    name: "User Management",
    route: "/message",
    icon: "cil-user-unfollow",
    _children: [
      {
        _tag: "CSidebarNavItem",
        name: "User list",
        to: "/user/list",
      },
      {
        _tag: "CSidebarNavItem",
        name: "User Roles",
        to: "/user/roles",
      },
      {
        _tag: "CSidebarNavItem",
        name: "System Permissions",
        to: "/user/permission",
      },
    ],
  },
  {
    _tag: "CSidebarNavDropdown",
    name: "System Reports",
    route: "/message",
    icon: "cil-file",
    _children: [
      {
        _tag: "CSidebarNavItem",
        name: "Revenues",
        to: "/report/revenue/list",
      },
      {
        _tag: "CSidebarNavItem",
        name: "Ageing Report",
        to: "/report/aging/analysis",
      },
    ],
  },
  {
    _tag: "CSidebarNavDropdown",
    name: "Settings",
    route: "/notifications",
    icon: "cil-settings",
    _children: [
      {
        _tag: "CSidebarNavItem",
        name: "Provider Mangement",
        to: "/provider/management",
      },
      {
        _tag: "CSidebarNavItem",
        name: "Preferences",
        to: "/settings/preference",
      },
    ],
  },
];

export default _nav;
